// Stripe Customer Portal "login link" — the safe, no-auth way to let customers
// self-serve cancel / update card / download invoices.
//
// Get it from: Stripe Dashboard → Settings → Billing → Customer portal → enable
// it (tick "Cancel subscriptions"), then copy the **login link** (a public,
// shareable URL of the form https://billing.stripe.com/p/login/...).
//
// Paste it below. While it's empty, the "Manage / cancel subscription" links
// stay hidden site-wide.
export const STRIPE_PORTAL_URL = 'https://billing.stripe.com/p/login/5kQ00bgHJ5R96w1clLaMU00';
